
import StatsMetrics from "./stats/StatsMetrics";
import BudgetManagement from "./stats/BudgetManagement";
import MediaPlanning from "./stats/MediaPlanning";
import DataDriven from "./stats/DataDriven";

const Stats = () => {
  return (
    <div className="space-y-0">
      <StatsMetrics />
      <BudgetManagement />
      <MediaPlanning />
      <DataDriven />
    </div>
  );
};

export default Stats;
